import React from 'react';
import FlightTakeoff from '@mui/icons-material/Flight';
import Engineering from '@mui/icons-material/Engineering';

const shortName = name => {
  const parts = (name || '').trim().split(/\s+/);
  if (parts.length < 2 || name === 'Staff member') return name;
  const lastName = parts.pop();
  return `${parts.join(' ')} ${Array.from(lastName)[0]}`;
};

export default function DayRotaSummary({summary, loading, error, compact = false}) {
  const leave = summary?.leave || [];
  const hasShifts = summary?.shiftCount > 0;
  if (!loading && !error && !hasShifts && !leave.length) return null;
  return <div style={{minWidth: 0, width: '100%', margin: '0 0 10px', paddingLeft:compact ? 0 : 2, fontSize: compact ? 10 : 12, color: '#000', boxSizing: 'border-box', overflowWrap: 'anywhere'}}>
    {error ? <span>Rota unavailable</span> : loading ? <span>Loading rota…</span> : <>
      {hasShifts && <div style={{display: compact ? 'grid' : 'flex', alignItems: 'center', flexWrap: 'wrap', gap: compact ? 2 : 5, lineHeight: compact ? '15px' : '18px',
        marginBottom: leave.length ? 10 : 0}}
        title="Scheduled working shifts and hours; leave is excluded. Hours are assigned to the shift’s start day and breaks are not deducted.">
        <span style={{display: 'inline-flex', alignItems: 'center', gap: compact ? 2 : 5, whiteSpace: 'nowrap'}}>
          <Engineering aria-label="Scheduled work" style={{fontSize: compact ? 12 : 18, flexShrink: 0, color: '#356c92'}} />
          <span aria-label={compact ? `${summary.shiftCount} shifts` : undefined}>
            {summary.shiftCount}{!compact && ` ${summary.shiftCount === 1 ? 'shift' : 'shifts'} ·`}
          </span>
        </span>
        <span style={{color: '#356c92', fontWeight: 600, whiteSpace: 'nowrap', minWidth: 0,
          ...(compact ? {fontSize: 9, overflow: 'hidden', textOverflow: 'ellipsis'} : {})}}>
          {(summary?.scheduledHours || 0).toLocaleString('en-GB', {maximumFractionDigits: 1})} h
        </span>
      </div>}
      {leave.length > 0 && <div style={{display: 'flex', flexWrap: compact ? 'wrap' : 'nowrap', alignItems: 'flex-start', gap: compact ? 2 : 5}}>
        <FlightTakeoff aria-label="On leave" style={{fontSize: compact ? 12 : 18, transform: 'rotate(-45deg)', flexShrink: 0, color: '#127866'}} />
        <div title={leave.map(person => person.name).join(', ')} style={{minWidth: 0, lineHeight: '18px'}}>
          {compact ? <span>{leave.length} off</span> : leave.map((person, index) => <React.Fragment key={person.userId}>
            {index > 0 && ' '}
            <span style={{whiteSpace: 'nowrap'}}>{shortName(person.name)}{index < leave.length - 1 ? ',' : ''}</span>
          </React.Fragment>)}
        </div>
      </div>}
    </>}
  </div>;
}
